
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const BlogPostSkeleton = () => (
  <Card className="h-full overflow-hidden">
    <Skeleton className="aspect-[16/9] w-full" />
    <CardHeader className="pb-2">
      <Skeleton className="h-4 w-24" />
      <Skeleton className="h-6 w-full" />
    </CardHeader>
    <CardContent>
      <Skeleton className="h-4 w-full mb-2" />
      <Skeleton className="h-4 w-5/6" />
    </CardContent>
    <CardFooter>
      <Skeleton className="h-5 w-28" />
    </CardFooter>
  </Card>
);

